import { isSpecialSubdomain } from "~/utils/helper";

export default defineNuxtRouteMiddleware(async (to, from) => {
  const host = window.location.host;
  const subdomain = host.split(".")[0];
  const auth = useAuth();
  const config = useRuntimeConfig();

  if (!auth.user?.accounts_count) {
    return;
  }

  if (!isSpecialSubdomain(subdomain) && to.path === "/switch") {
    return navigateTo("/hub/sessions");
  } else {
    return;
  }
});
